export default __webpack_public_path__ + "media/color/gsc-4163b722.svg";